export default "__VITE_ASSET__2w3dSD$K__"